// extracted by mini-css-extract-plugin
module.exports = {"input":"idt-fileuploader_input__3wgj5"};